export const TRANSLATION_KEYS = {
  // Latest HP Revenue: FY24 $56M
  pyActualsFieldLabel: 'partnerbasicinfo-fin-py-actuals',

  // Current Joint business plan: FY25 $80.2M
  cyPlansFieldLabel: 'partnerbasicinfo-fin-cy-plans',
}
